import { css } from '@/styled-system/css';

export const expiredCaptionContainerStyles = css.raw({
  display: 'flex',
  width: '160px',
  padding: 'tighter',
  paddingBottom: 'default',
  border: '1px solid',
  borderColor: 'border.muted',
  borderTop: 'none',
  borderRadius: '300',
  borderTopRightRadius: '0',
  borderTopLeftRadius: '0',
  marginTop: '-4px',
});

export const imageThumbnailPlaceholderStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'bg.softest',
  borderRadius: '300',
  border: '1px solid',
  borderColor: 'border.muted',
});
